<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <div v-if="events.length == 1">
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <div v-if="events.length > 0">
      <div class="text-left">
        <!-- <v-chip class="ma-2" color="accent">
        <v-avatar left>
          <v-icon>event</v-icon>
        </v-avatar>
        {{ title }}
      </v-chip> -->
        <v-chip class="ma-2" color="brand onBrand--text">
          <v-avatar left>
            <v-icon>event</v-icon>
          </v-avatar>
          <span v-if="curr_month != null"> {{ curr_month }} </span>
          <span v-else> {{ title }} </span>
        </v-chip>
        <v-chip class="ma-2" color="brand onBrand--text" @click="setToday">Go To Today
        </v-chip>
      </div>
      <v-card>
        <v-card-title class="brand onBrand--text"> Group Calendar </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12" sm="6" md="6">
              <v-select :items="communication_groups" prepend-icon="mdi-account-child-circle" item-text="title"
                item-value="id" hint="Select Group" persistent-hint @change="getCalenderEvents(selected_group)" outlined
                dense v-model="selected_group"></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <br />
      <v-sheet tile color="grey lighten-3">
        <v-row justify="center" style="margin-left: 10px; margin-right: 10px">
          <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-select v-model="type" :items="types" dense outlined hide-details class="ma-2" label="type"></v-select>

          <v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="weekdays"
            class="ma-2"></v-select>

          <v-btn icon class="ma-2" @click="$refs.calendar.next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </v-sheet>
      <v-sheet height="520">
        <v-calendar ref="calendar" v-model="value" :weekdays="weekday" :type="type" :events="events"
          :event-overlap-threshold="30" :event-color="getEventColor" @change="getEvents" @click:event="showEvent"
          @click:day="getdata" @click:more="viewDay"></v-calendar>
      </v-sheet>
      <template>
        <div class="text-center">
          <v-dialog v-model="dialog" width="500">
            <v-card>
              <v-card-title class="headline" primary-title>
                {{ tempevents.name }}
              </v-card-title>

              <v-card-text>
                <div class="headline mb-2">
                  Description : {{ tempevents.description }}
                </div>
                <!-- <v-chip
            class="mr-2"
            @click="lights"
            color="lightgreen"
            text-color="white"
        >
            <v-icon  left>mdi-brightness-5</v-icon>
            Class: {{tempevents.std}}
        </v-chip>
            <v-chip
            class="mr-2"
            @click="lights"
            color="lightgreen"
            text-color="white"
        >
            <v-icon  left>mdi-brightness-5</v-icon>
            GRNO: {{tempevents.grno}}
        </v-chip> -->
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    selected_group: "",
    communication_groups: [],
    dialog: false,
    datetime: null,
    title: "",
    type: "month",
    types: ["month", "week", "day"],
    mode: "stack",
    modes: ["stack", "column"],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    weekdays: [
      { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
      { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
      { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
    ],
    value: "",
    events: [],
    tempevents: { name: "", description: "", std: "", grno: "" },
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    months: [
      "",
      "Jan",
      "Feb",
      "Mar",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    curr_month: null,
  }),
  updated: function () {
    //console.log("Inside updated");
    this.$nextTick().then(() => {
      if (this.$refs.calendar.value != "") {
        console.log(this.$refs.calendar.value);
        let date = this.$refs.calendar.value;
        var no = date.split("-");
        console.log(no[1]);
        this.curr_month = this.months[parseInt(no[1])];
        console.log(this.curr_month);
      }
    });
  },
  methods: {
    viewDay({ date }) {
      this.value = date;
      this.type = "day";
    },
    setToday() {
      this.value = "";
      this.curr_month = null;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    dateTime() {
      let dt = this.formatDate(this.datetime, true);
      const formData = {
        datetime: dt,
      };
      console.log(formData);
      axios
        .post("tryNError/dateTime", formData)
        .then((res) => {
          if (res.data.msg == "200") {
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    showEvent({ nativeEvent, event }) {
      this.tempevents.name = event.name;
      this.tempevents.description = event.description;
      //   this.tempevents.std=event.std;
      //   this.tempevents.grno=event.grno;
      this.dialog = true;
      const formData = {
        event: event.id,
      };
      axios
        .post("communicationGroup/markViewed", formData)
        .then((res) => {
          if (res.data.msg == "200") {
          } else {
            //this.showSnackbar("#b71c1c", "No Events Available For This Group..!!!");
            //return
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      //alert(event.name + " " + event.description + " " + event.std);
    },
    getdata({ day }) {
      // alert(day)
    },
    getEventData(start) {
      return start == this.value;
    },
    getEvents() {
      //alert(this.value)
    },
    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${
            a.getMonth() + 1
          }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    getMonthYYYYMMDD(date) {
      var num_month = date.split("-");
      var months = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[parseInt(num_month[1])];
    },
    getCalenderEvents(item) {
      //alert("selected_group::"+item)
      const formData = {
        group_id: item,
      };
      axios
        .post("communicationGroup/getCalenderEvents", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.eventInfo.length !== 0) {
              this.events = res.data.eventInfo;
            } else {
              this.showSnackbar(
                "#b71c1c",
                "No Events Available For This Group..!!!"
              );
              return;
            }
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    onload() {
      this.events.push({
        name: "Happy New Year", //title
        start: "2020-01-01", //this.formatDate(res.data.date, !true),
        end: "2020-01-01", //this.formatDate(res.data.date, !true),
        color: "",
        description: "",
        std: "",
        div: "",
      });
      axios
        .get("communicationGroup/getCalendar")
        .then((res) => {
          if (res.data.msg == "200") {
            this.communication_groups = res.data.communication_groups;
            //   if (res.data.eventInfo.length !== 0) {
            //     this.events = res.data.eventInfo;
            //     console.log(this.events);
            //   }
            //   this.events.push({
            //         name: "vikas",//title
            //         start: res.data.date,//this.formatDate(res.data.date, !true),
            //         end: res.data.date,//this.formatDate(res.data.date, !true),
            //         color: "red",
            //         description:"More Info...",
            //         std:"UKG",
            //         div:"A",
            //     })
            this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
